<!-- @format -->

<template>
  <div class="table">
    <ul class="FJ_GZZDYJLB_Nav" :style="{ height: TableStyle.NavHeight, width: TableStyle.TableWidth }">
      <li
        v-for="(item, index) of NavData"
        :key="index"
        :style="{
          lineHeight: TableStyle.NavlineHeight,
          marginTop: TableStyle.NavTop,
          width: TableCountWidth[index],
        }"
      >
        {{ item }}
      </li>
    </ul>
    <div
      :style="{ width: TableStyle.TableWidth, height: TableStyle.Height }"
      class="swiper_wraper FJ_GZZDYJLB_Content"
      @mouseenter="enterSwiper"
      @mouseleave="leaveSwiper"
    >
      <swiper
        v-if="Data.length > 1"
        class="wrap"
        :style="{ height: TableStyle.Height }"
        ref="mySwiper"
        :options="swiperOptions"
        :auto-update="true"
        :auto-destroy="true"
        :delete-instance-on-destroy="true"
        :cleanup-styles-on-destroy="true"
      >
        <swiperSlide class="swipe_inner" v-for="(item, index) of Data" :key="index">
          <div :style="{ width: TableCountWidth[0] }">{{ item.first }}</div>
          <div :style="{ width: TableCountWidth[1] }">{{ item.second }}</div>
          <div :style="{ width: TableCountWidth[2] }">{{ item.third }}</div>
          <div :style="{ width: TableCountWidth[3] }">{{ item.fourth }}</div>
          <div :style="{ width: TableCountWidth[4] }">{{ item.five }}</div>
        </swiperSlide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
let vm = null;
export default {
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    NavData: {
      type: Array,
      default: () => {
        return ['编号', '时间', '详情', '办结情况'];
      },
    },
    TableCountWidth: {
      type: Array,
      default: () => {
        return ['64px', '66px', '66px', '66px', '66px', '66px', '66px'];
      },
    },
    TableStyle: {
      type: Object,
      default: () => {
        return {
          TableWidth: '400px',
          NavHeight: '30px',
          NavlineHeight: '30px',
          NavTop: '0px',
          Height: '320px',
        };
      },
    },
    slidesPerView: {
      type: Number,
      default: () => {
        return 4;
      },
    },
    Data: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      // 轮播图配置
      swiperOptions: {
        direction: 'vertical',
        // observer: true,
        // observeParents: true,
        observer: true,
        observeParents: true,
        loopFillGroupWithBlank: true,
        initialSlide: 0,
        loop: true,
        slidesPerView: 'auto',
        autoplay: {
          delay: 3000,
          disableOnInteraction: true,
        },
      },
      on: {
        click: function() {
          // 这里有坑，需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
          // console.log(this); // -> Swiper
          // 当前活动块的索引，与activeIndex不同的是，在loop模式下不会将 复制的块 的数量计算在内。
          let index = this.clickedIndex % vm.Data.length;
          vm.handleClickSlide(index);
        },
      },
    };
  },
  methods: {
    // enterSwiper() {},
    // leaveSwiper() {},
    enterSwiper() {
      this.swiper.autoplay.stop();
    },
    leaveSwiper() {
      this.swiper.autoplay.start();
    },
    handleClickSlide(index) {
      this.$emit('clickItem', index);
    },
  },
  created() {
    vm = this;
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
};
</script>

<style lang="less" scoped>
.table {
  // width: 408px;
  .FJ_GZZDYJLB_Nav {
    margin-top: 10px;
    width: 408px;
    height: 70px;
    display: flex;
    justify-content: space-between;
    background: rgba(77, 121, 255, 0.2);
    padding: 0 3px;
    box-sizing: border-box;
    li {
      height: 70px;
      // line-height: 66px;
      font-size: 26px;
      color: #FFF;
      text-align: center;
      font-family: 'Helvetica';
      //   &:nth-child(1) {
      //     width: 71px;
      //   }
      //   &:nth-child(2) {
      //     width: 237px;
      //   }
      //   &:nth-child(3) {
      //     width: 257px;
      //   }
      //   &:nth-child(4) {
      //     width: 222px;
      //   }
    }
  }

  .FJ_GZZDYJLB_Content {
    width: 408px;
    height: 268px;
    text-align: center;
    .wrap {
      height: 268px;
    }
    .swipe_inner {
      height: 67px !important;
      line-height: 67px;
      box-sizing: border-box;
      background: #104070;
      font-size: 24px;
      color: #D8D8EA;
      font-family: 'Helvetica';
      display: flex;
      justify-content: space-between;
      padding: 0 3px;
      box-sizing: border-box;
      &:nth-child(odd) {
        background: transparent;
        border-bottom: 1px solid rgba(255,255,255,.15);
      }
      &:nth-child(even) {
        background: transparent;
        border-bottom: 1px solid rgba(255,255,255,.15);
      }
      //   & > div:nth-child(1) {
      //     width: 71px;
      //   }
      //   & > div:nth-child(2) {
      //     width: 237px;
      //   }
      //   & > div:nth-child(3) {
      //     width: 257px;
      //   }
      //   & > div:nth-child(4) {
      //     width: 222px;
      //   }
    }
  }
}
</style>
